import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const FLEX_GRADIENT_SVG_ID = {
  tropical: "flex-gradient-svg-tropical",
  magic: "flex-gradient-svg-magic",
  flame: "flex-gradient-svg-flame",
  mango: "flex-gradient-svg-mango"
};
function FlexLinearGradient({ id }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("linearGradient", { id: getID("flame", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#f96919" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#FB60BD" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { id: getID("magic", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#a348ff" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#6066FF" })
    ] }),
    /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: getID("tropical", id),
        gradientTransform: "rotate(4.77)",
        children: [
          /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#04CC00" }),
          /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#12C2CD" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("linearGradient", { id: getID("mango", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#FA9E00" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#FF8E26" })
    ] })
  ] });
}
function getID(gradient, suffix) {
  return `${FLEX_GRADIENT_SVG_ID[gradient]}-${suffix}`;
}

export { FLEX_GRADIENT_SVG_ID, FlexLinearGradient, getID };
//# sourceMappingURL=FlexLinearGradient.mjs.map
